// 印尼语
export default {
  'SLModal.default.okText': 'Selesai',
  'SLModal.default.cacelText': 'Batal',
  'SLModal.info.okText': 'Saya sudah tahu',
  'SLPopconfirm.cancelText': 'Batal',
  'SLPopconfirm.okText': 'Konfirmasi',
  'SLModal.danger.okText': 'Hapus',
  'SLUpload.default.image.addImage': 'Tambah gambar',
  'SLUpload.default.image.restImages': 'Lihat gambar {{len}} yang tersisa',
  'SLUpload.default.image.loading': 'mengunggah...',
  'SLUpload.default.image.fail': 'Gagal unggah, silakan coba lagi',
  'SLUpload.default.image.delete.title': 'Konfirmasikan hapus?',
  'SLUpload.default.image.delete.content': 'Tidak bisa dipulihkan setelah dihapus.',
  'SLUpload.ALTFormModal.placeholder': 'Silakan masukkan atribut ALT gambar',
  'SLUpload.ALTFormModal.tip': 'Edit atribut ALT gambar berguna untuk membantu mencari optimalisasi mesin (SEO)dan pengalaman tunanetra',
  'SLUpload.ALTFormModal.title': 'Edit atribut ALT gambar',
  'SLUpload.ALTFormModal.length': 'Tidak boleh melebihi {{max}} karakter',
  'SLUpload.uploadfile.fail': 'gagal mengunggah',
  'SLUpload.uploadfile.fail1': 'Format file salah',
  'SLUpload.uploadfile.sucess': 'Mengunggah kesuksesan',
  'SLUpload.uploadfile.text1': 'Unggah file',
  'SLUpload.uploadfile.text2': '',
  'SLUpload.uploadfile.progress': 'Sedang mengunggah..',
  'SLUpload.dragUploading': 'Lepaskan mouse untuk mengunggah',
  'SLUpload.default.image.description': 'Ukuran yang disarankan adalah 256 x 116',
  'SLUpload.default.image.fail.title': '{{fileName}} gagal diunggah',
  'SLUpload.default.image.fail.desc1': 'ukurannya tidak boleh melebihi{{max}}MB',
  'SLUpload.default.image.fail.desc2': 'Unggah nama tidak boleh melebihi {{max}} karakter',
  'SLUpload.default.image.fail.desc3': 'File telah melebihi resolusi maksimum {{limitPx}}MP. Silakan kurangi resolusi, lalu coba lagi',
  'SLUpload.default.image.fail.desc4': 'Maaf! Maksimal bisa mengunggah {{maxNum}} gambar!',
  'SLUpload.uploadField.errorMsg4': 'Gambar gagal diunggah',
  'SLUpload.uploadField.upload': 'Mengunggah gambar',
  'SLUpload.SLImage.preview.closeText': 'Tutup'
};